
import {Component, Vue} from "vue-property-decorator";
import {UserLocation} from "@/shared/services/UserLocation";
import {TApiResponse, TPDFCatalogItem} from "@/PDFCataloqueList/TApiResponse";
import moment from 'moment';
import {OfferService} from "@/shared/services/OfferService";

@Component({})
export default class NavLocation extends Vue {

  private readonly content_id: string = this.$parent.$data.contentId;
  private userLocation: string | null = null;
  private pdfCatalogList: TPDFCatalogItem[] = [];

  async mounted() {
    window.addEventListener('OfferMarketChanged', () => this.initializeView());
    this.userLocation = this.$parent?.$data?.value || UserLocation.get();

    // calls initializeView
    OfferService.setOfferLocation(this.userLocation!, '');
  }

  async initializeView() {
    const url = OfferService.hasOfferLocation()
        ? `/.rest/personalized/v1/pdfcatalogs/${this.content_id}/${OfferService.getOfferLocation()}?size=width640&size=width480&size=width300`
        : `/.rest/personalized/v1/pdfcatalogs/${this.content_id}?size=width640&size=width300`;

    const response = await fetch(url);
    const json: TApiResponse = await response.json();

    this.pdfCatalogList = [];
    Object.keys(json).forEach((category => {
      this.pdfCatalogList = this.pdfCatalogList.concat(
          json[category].map(item => item.pdfCatalogItem)
      );
    }));
  }

  updated() {
    (window as any).reinitializePDFViewer();
  }

  formatValidity(catalog: TPDFCatalogItem) {
    const fromFormat = 'DD.MM.';
    const toFormat = 'DD.MM.YYYY';
    const from = moment(catalog.clickableFrom);
    const to = moment(catalog.clickableTo);
    const toFormatedDate = to.format(toFormat);

    if (from.format(toFormat) === toFormatedDate) return toFormatedDate;
    return `${from.format(fromFormat)} - ${toFormatedDate}`;
  }

  private getSlotContent(slotName: string) {
    const textSlot = this.$scopedSlots[slotName];
    if(!textSlot) return false;
    const slot = textSlot({});
    if(!slot?.length) return false;

    return slot[0].text;

  }

  get text() {
    return this.getSlotContent('text');
  }

  get headline() {
    return this.getSlotContent('headline');
  }
}
